import React from "react";
import styles from "./MultiAccountPreference.scss";
import { getLocalizedStrings } from "../centralizedLocalizedString";
import Header from "./Presentational/Header";
import MultiAccountTray from "./Presentational/MultiAccountTray";
import GlobalErrorCard from "./Presentational/GlobalErrorCard";
import UISearchBar from "../common/cpcSearchBar/cpcSearchBar";
import Pagination from "../common/Pagination";

class MultiAccountPreference extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings("AccountPreference");
    this.state = {
      data: {
        marketingPref: [],
        contractAccountResults: [],
      },
      accountDetails: [],
      preferenceDetails: [
        {
          papr: {
            email_id: [],
          },
          outg: {
            email_id: [],
            phoneNo: [],
            textNo: [],
            directMail:null,
          },
          emrg: {
            email_id: [],
            phoneNo: [],
            textNo: [],
          },
          buda: {
            email_id: [],
            phoneNo: [],
            textNo: [],
          },
          cpp: {
            email_id: [],
            phoneNo: [],
            textNo: [],
          },
        },
      ],
      errorCard: undefined,
      isWebUser: false,
      showError: false,
      refreshPref: "",
      errorResponse: "",
      emailPref: "",
      isContractNull: false,
      Name: "",
      bpNumber: "",
      accountsPerPage: 10,
      totalPages: "",
      currentPage:this.props.currentPage
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
      let totalPages = Math.ceil(
        this.props.cpcData.contractAccountCount / this.state.accountsPerPage
      );
      //   let startPage = Math.floor(this.props.currentPage/10) + 1;
      //   let endPage = startPage + 9;
  
      this.setState({
        totalPages: totalPages,
        totalAccounts: nextProps.totalPages,
        preferenceDetails: this.props.preferenceDetails,
        startPage: nextProps.startPage,
        endPage: nextProps.endPage,
        currentPage: nextProps.currentPage
      });
    }
  }

  render() {
    return (
      <div>
        <div className={styles.ConHeading}>
          {this.strings.AccountPreferenceLabel}
        </div>
        
        <UISearchBar
          cactList={this.props.cactList}
          searchText={this.props.searchText}
          selectedType={this.props.searchType}
          filterSearchedCactList={this.props.filterSearchedCactList}
          strings={this.props.strings}
          getCactListServiceCall={this.props.getCactListServiceCall}
          getCactListDataFn={this.props.getCactListDataFn}
        />
        {this.props.showSearchError?<span className={styles.searchError}>{this.strings.searchErrMsgOne}{this.props.searchtypeError}</span> :
        <div>
<div className={styles.PagesNumber}>
{(this.state.totalAccounts > 10) ?
  <div>
  {this.state.totalPages !== 1? this.state.startPage + "-" +this.state.endPage +" of "+ this.state.totalAccounts +" accounts" : null}</div>  
: null}
        </div>
        {this.props.accountDetails.map((data,i) => {
          return (
            <div className={styles.HeaderCard}>
              <Header
                isContractAccountExpanded={this.props.isContractAccountExpanded}
                onContractAccountClick={this.props.onContractAccountClick}
                isMultiAcc={this.props.isMultiAcc} onPbToggleOnOffClick={this.props.onPbToggleOnOffClick}
                accountDetails={data}
                contractAccountNumber={this.props.contractAccountNumber}
              />
              {this.props.isContractAccountExpanded &&
              data.contractAccountNumber ===
                this.props.contractAccountNumber ? (
                <MultiAccountTray
                  isContractResultExpanded={this.props.isContractResultExpanded}
                  onContractAccountClick={this.props.onContractAccountClick}
                  onContractResultClick={this.props.onContractResultClick}
                  contractNumber={this.props.contractNumber} dropDownData={this.props.dropDownData}
                  contractResults={data.contractResults} updateDropDownData={this.props.updateDropDownData}
                  preferenceDetails={this.state.preferenceDetails}
                  accountDetails={data} staticContent={this.props.staticContent}
                  handleShowMore={this.props.handleShowMore}
                  handleShowLess={this.props.handleShowLess}
                  viewShowMoreContracts={this.props.viewShowMoreContracts}
                  viewShowLessContracts={this.props.viewShowLessContracts}
                  customerData={this.props.customerData}
                  formattedDataForCpp={this.props.formattedDataForCpp}
                  isMultiAcc={this.props.isMultiAcc}
                  cpcData={this.props.cpcData} isWebUser={this.props.isWebUser}
                  contractAccountCount={this.props.cpcData.contractAccountCount}
                  getMyAccountDetails={this.props.getMyAccountDetails} removePreference={this.props.removePreference}
                  getWebUserDetails={this.props.getWebUserDetails} baEnrollmentDetailsVO={this.props.baEnrollmentDetailsVO} onlyOneBpEnrolled={this.props.onlyOneBpEnrolled} cpcPageNumber={this.state.currentPage}
                   paprRecord={this.props.paprRecord} formattedDataForEmrg={this.props.formattedDataForEmrg} formattedDataForOutg={this.props.formattedDataForOutg} formattedDataForBuda={this.props.formattedDataForBuda}
                   ebillpaprCount={this.props.ebillpaprCount} onPbToggleOnOffClick={this.props.onPbToggleOnOffClick} ebillpaprRecord={this.props.ebillpaprRecord}
                   ebillpaprSold={this.props.ebillpaprSold} ebillpaprAuth={this.props.ebillpaprAuth} prefData={this.props.prefData} depaprRecord={this.props.depaprRecord} billingRateType={this.props.billingRateType}
                   />
              ) : null}
            </div>
          );
        })}
        <div className={"row"}>
          <div
            className={
              "col-xs-12 " + styles.scePageSpace
            }
          >

            <div className={styles.overviewPagination}>
            {this.state.totalAccounts > 10 ?
              <Pagination
              pageCount={this.state.totalPages}
              getCurrentIndex={(e) => this.props.handlePageChange(e)}
              pageScale={5}
              value={this.props.currentPage}
            />  : null}
            </div>
          </div>
        </div>
        </div>
        }
      </div>
    );
  }
}
export default MultiAccountPreference;
